import appReducer from './app/reducer';
import profileReducer from './profile/reducer';

export default {
  app: appReducer,
  profile: profileReducer
};
